<template>
  <ul class="flex items-center gap-2">
    <li
      class="cursor-pointer"
      :class="{
        'grayscale-0': currentLocale.code !== locale.code,
        'grayscale hover:grayscale-0': currentLocale.code == locale.code,
      }"
      @click="setLocale(locale)"
      v-for="locale in locales"
    >
      <NuxtLink :to="switchLocalePath(locale.code)">
        <img :src="locale.icon" class="w-5" :alt="locale.name" />
        <span class="sr-only">
          {{ locale.name }}
        </span>
      </NuxtLink>
    </li>
  </ul>
</template>
<script lang="ts" setup>
const { locale, locales } = useI18n();

var currentLocale = computed(() => {
  return locales.value.find((i) => i.code == locale.value);
});

</script>
